/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Row_ImportInputs */

const en_us2_history_transfer_row_import = /** @type {(inputs: History_Transfer_Row_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import history`)
};

const pt_br2_history_transfer_row_import = /** @type {(inputs: History_Transfer_Row_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar histórico`)
};

const es_419_history_transfer_row_import = /** @type {(inputs: History_Transfer_Row_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar historial`)
};

const pt_pt2_history_transfer_row_import = /** @type {(inputs: History_Transfer_Row_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar histórico`)
};

const fr_fr2_history_transfer_row_import = /** @type {(inputs: History_Transfer_Row_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer l'historique`)
};

const de_de2_history_transfer_row_import = /** @type {(inputs: History_Transfer_Row_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlauf importieren`)
};

const it_it2_history_transfer_row_import = /** @type {(inputs: History_Transfer_Row_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa storico`)
};

/**
* | output |
* | --- |
* | "Import history" |
*
* @param {History_Transfer_Row_ImportInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_row_import = /** @type {((inputs?: History_Transfer_Row_ImportInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Row_ImportInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_row_import(inputs)
	if (locale === "es-419") return es_419_history_transfer_row_import(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_row_import(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_row_import(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_row_import(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_row_import(inputs)
	return en_us2_history_transfer_row_import(inputs)
});
export { history_transfer_row_import as "history-transfer.row_import" }